// extracted by mini-css-extract-plugin
module.exports = {"benefitsList":"SubscriptionBenefits_benefitsList__d_8uu","benefitItem":"SubscriptionBenefits_benefitItem__AKsfa","checkIcon":"SubscriptionBenefits_checkIcon__gkBSv"};